import { SPECIFY_CLOSE_MEMBERS } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (
  memberId: string,
  termNumber: number,
  assessors: string[],
  token: string
) =>
  fetch(SPECIFY_CLOSE_MEMBERS(memberId, termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({ closeMembersIds: assessors }),
  }).then(errorHandler)
